/* This is an obsolete component after CM-206 */
import React from 'react';
import theme from './ProjectInviteIntro.module.scss';
import { Trans } from '@lingui/react/macro';
import { ModalBody, ModalFooter, ModalHeader, Modal } from '@ygtechnologies/bygr-frontend-component-library';
import { SimpleCard } from '@/components/Cards';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserHardHat, faUserFriends } from '@fortawesome/pro-light-svg-icons';
import { Button } from '@/components/Buttons';
import { IState } from '@/state/IState';
import { useSelector } from 'react-redux';
import { CustomLink } from '@/components/navigation';

type Props = {
    onCancel(): void;
    isOpen: boolean;
};

const ProjectInviteIntro: React.FC<Props> = ({ onCancel, isOpen }) => {
    const projectName = useSelector((state: IState) => state.global.activeProject!.name);
    const projectId = useSelector((state: IState) => state.global.activeProject!.id);

    return (
        <Modal isOpen={isOpen}>
            <ModalHeader>
                <Trans>Add a user to {projectName}</Trans>
            </ModalHeader>
            <ModalBody>
                <Trans>Which kind of user are you inviting?</Trans>
                <CustomLink className="link-unstyled" to={`/projects/${projectId}/users/add`}>
                    <SimpleCard className={theme.card}>
                        <FontAwesomeIcon icon={faUserFriends} />
                        <div>
                            <h5>
                                <Trans>A colleague</Trans>
                            </h5>
                            <p>
                                <Trans>
                                    This is a user that works in the same organisation as you do. You can search users from
                                    your organisation by name and e-mail.
                                </Trans>
                            </p>
                        </div>
                    </SimpleCard>
                </CustomLink>
                <CustomLink className="link-unstyled" to={`/projects/${projectId}/users/invite`}>
                    <SimpleCard className={theme.card}>
                        <FontAwesomeIcon icon={faUserHardHat} />
                        <div>
                            <h5>
                                <Trans>A contractor or a vendor</Trans>
                            </h5>
                            <p>
                                <Trans>
                                    This is a user that works for an organisation that your company hired to do a job. You
                                    need to know both the organisation name and e-mail of the user you are inviting.
                                </Trans>
                            </p>
                        </div>
                    </SimpleCard>
                </CustomLink>
            </ModalBody>
            <ModalFooter>
                <div>
                    <Button color="tertiary" onClick={onCancel}>
                        <Trans>Cancel</Trans>
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    );
};

export default ProjectInviteIntro;
